export const paths = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/confirmations/:id/password',
  signUpConfirmation: '/confirmations/:id/registration',
  invitationConfirmation: '/confirmations/:id/invitation',
  emailChangeConfirmation: '/confirmations/:id/email',

  figmaIntegrationRedirect: '/figma-integration-redirect',
  googleAuthRedirect: '/google-auth-redirect',

  projects: '/projects',
  projectDetails: '/projects/:projectId',
  projectOverview: '/projects/:projectId/overview',
  projectTerms: '/projects/:projectId/terms',
  projectUsers: '/projects/:projectId/users',
  projectSettings: '/projects/:projectId/settings',
  projectHistory: '/projects/:projectId/history',

  gitlabIntegration: '/projects/gitlab-integration',

  profileSettings: '/profile-settings',
  settings: '/settings',

  plans: '/plans',
  planPurchase: '/plans/purchase',

  payments: '/payments',
} as const
